import React, { useState, useEffect } from 'react'
import AdminRolePicker from './AdminRolePicker'
import Role from './Role'
import { Trash2 } from 'react-feather'

export default function PageAuthorization({
    parentRef,
    index,
    showSystemMessage,
    roles,
    record,
    addDeleteRole,
    changePrivilege,
    deleteAuth,
    addNote,
    authorizationData,
}) {
    const [selectedRolesToAdd, setSelectedRolesToAdd] = useState([])
    const [deleteInit, setDeleteInit] = useState(false)
    const [notes, setNotes] = useState('')

    useEffect(() => {
        setSelectedRolesToAdd([])
        setDeleteInit(false)
    }, [record])

    const handleAddRoles = () => {
        if (!selectedRolesToAdd || selectedRolesToAdd.length === 0) return

        selectedRolesToAdd.forEach((roleId) => {
            addDeleteRole('add', 'portal', record.id, roleId)
        })

        setSelectedRolesToAdd([])
    }

    return (
        <tr ref={(el) => (parentRef.current[index] = el)}>
            <td>
                <div className="d-flex align-items-center">
                    <div>{record.resource}</div>
                    {record.roles.length <= 0 && (
                        <div>
                            {deleteInit ? (
                                <button className="btn btn-lnk btn-sm text-danger ml-2" onClick={() => deleteAuth('portal', record.id)}>
                                    Confirm
                                </button>
                            ) : (
                                <button className="btn btn-sm ml-2">
                                    <Trash2 size={16} color="red" onClick={() => setDeleteInit(true)} />
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </td>
            <td>
                {record.roles.map((role) => (
                    <Role
                        role={role}
                        record={record}
                        addDeleteRole={addDeleteRole}
                        changePrivilege={changePrivilege}
                        mode="portal"
                        key={role.id}
                        authorizationData={authorizationData}
                    />
                ))}

                <div className="d-flex">
                    <AdminRolePicker
                        record={record}
                        selectRole={setSelectedRolesToAdd}
                        selectedRoles={selectedRolesToAdd}
                        passedRoles={roles}
                        showSystemMessage={showSystemMessage}
                    />

                    {selectedRolesToAdd.length > 0 ? (
                        <button
                            className="ml-2 btn btn-sm btn-primary"
                            onClick={handleAddRoles}
                        >
                            Add Role{selectedRolesToAdd.length > 1 ? 's' : ''}
                        </button>
                    ) : (
                        <button className="ml-2 btn btn-sm btn-primary" disabled>
                            Add Role
                        </button>
                    )}
                </div>
            </td>
            <td style={{ height: '200px' }}>
                <textarea rows="5" cols="30" className="form-control" onChange={(e) => setNotes(e.target.value)}>
                    {record.notes}
                </textarea>
                <button className="btn btn-primary btn-sm mt-2" onClick={(e) => addNote('portal', record.resource, notes)}>Save Note</button>
            </td>
        </tr>
    )
}
